import { type MouseEvent } from 'react';
import { IconStarGray, IconStarYellow } from '@/assets/svgs';
import { useAuth, useLoginRequiredModal } from '@/entities/user';
import useSaveStation from '../model/useSaveStation';

type SaveStationButtonProps = {
	stationId: string;
};

const SaveStationButton = ({ stationId }: SaveStationButtonProps) => {
	const { isSaved, toggleSave } = useSaveStation(stationId);
	const { isLoggedIn } = useAuth();
	const openLoginRequiredModal = useLoginRequiredModal();

	const handleToggleSave = (e: MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();
		e.stopPropagation();

		if (!isLoggedIn) {
			openLoginRequiredModal();
			return;
		}

		toggleSave();
	};

	return (
		<button
			type="button"
			onClick={handleToggleSave}
			aria-label={isSaved ? '즐겨찾기 해제' : '즐겨찾기 추가'}
			className="cursor-pointer"
		>
			{isSaved ? <IconStarYellow /> : <IconStarGray />}
		</button>
	);
};

export default SaveStationButton;
